import React from 'react';
import { Alert, Box, ExpandableSection, Link, SpaceBetween } from '@cloudscape-design/components';

const currency = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });

export const fundingRecordPath = record => {
  if (!record.caseId) return null;
  const params = new URLSearchParams();
  if (record.interventionId) {
    params.set('entry', 'task');
    params.set('task', 'intervention-followup');
    params.set('interventionId', String(record.interventionId));
    if (record.actionPlanId) params.set('planId', String(record.actionPlanId));
    if (record.applicationId) params.set('applicationId', String(record.applicationId));
  }
  const query = params.toString();
  return `/cases/${record.caseId}${query ? `?${query}` : ''}`;
};

const Records = ({ records }) => (
  <SpaceBetween size="m">
    {records.map((record, index) => {
      const path = fundingRecordPath(record);
      return (
        <SpaceBetween key={record.id || index} size="xxs">
          <Box fontWeight="bold">{record.participantName || 'Participant unavailable'}
            {record.interventionName ? ` · ${record.interventionName}` : ''}
          </Box>
          <Box>{Number.isFinite(record.includedAmount)
            ? `${currency.format(record.includedAmount)} included in this report.`
            : 'Included amount unavailable.'} {record.explanation || record.reportingEffect || record.remediation}</Box>
          {path ? <Link href={path}>{record.interventionId ? 'Open intervention' : 'Open case'}</Link> : null}
        </SpaceBetween>
      );
    })}
  </SpaceBetween>
);

export default function FinanceFundingReview({ issues = [], explanations = [] }) {
  return (
    <SpaceBetween size="s">
      {issues.length > 0 ? (
        <Alert data-testid="finance-funding-review" type="warning" header="Funding records need review">
          <Records records={issues} />
        </Alert>
      ) : null}
      {explanations.length > 0 ? (
        <ExpandableSection headerText={`Approved reimbursements included (${explanations.length})`}>
          <Records records={explanations} />
        </ExpandableSection>
      ) : null}
    </SpaceBetween>
  );
}
